import React from "react";
import Progress6Svg from "../../../assets/svgicons/progress-bar/progress_bar_6.svg";

const Progress6 = (props) => {
  return <img src={Progress6Svg} alt="Progress 6" {...props} />;
};

export default Progress6;
